import { triniumApi } from '../../slice';
import { DispatchLeg, DispatchLegsBySearchRequest, transformDispatchLegsResponse } from './types';

export const dispatchSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchDispatchLegs: builder.query<DispatchLeg[], string>({
				query: (terminalNumber) => ({
					url: `/${terminalNumber}/dispatch`
				}),
				transformResponse: transformDispatchLegsResponse,
				providesTags: (result) =>
					result
						? [
								...result.map(({ legId }) => ({
									type: 'dispatch' as const,
									id: legId
								})),
								'dispatch'
							]
						: []
			}),
			fetchDispatchLegsByJobId: builder.query<DispatchLeg[], { terminalNumber: string; jobId: string }>({
				query: ({ terminalNumber, jobId }) => ({
					url: `/${terminalNumber}/dispatch/${jobId}`
				}),
				transformResponse: transformDispatchLegsResponse,
				providesTags: (result, _error, params) => (result ? [{ type: 'dispatch-by-job', id: params.jobId }] : [])
			}),
			fetchDispatchLegsBySearch: builder.query<DispatchLeg[], DispatchLegsBySearchRequest>({
				query: ({ terminalNumber, ...params }) => {
					return {
						url: `/${terminalNumber}/dispatch`,
						params: Object.entries(params).filter(([, value]) => value)
					};
				},
				transformResponse: transformDispatchLegsResponse,
				providesTags: (result) =>
					result
						? [
								...result.map(({ legId }) => ({
									type: 'dispatch-by-search' as const,
									id: legId
								})),
								// Constant tag so the whole search can be invalidated (e.g. after a cancellation, where a
								// row changes from an active leg to a no-leg cancelled row and there is no legId to target).
								{ type: 'dispatch-by-search' as const, id: 'LIST' }
							]
						: [{ type: 'dispatch-by-search' as const, id: 'LIST' }]
			})
		};
	}
});

export const {
	useFetchDispatchLegsQuery,
	useLazyFetchDispatchLegsQuery,
	useFetchDispatchLegsByJobIdQuery,
	useLazyFetchDispatchLegsBySearchQuery
} = dispatchSlice;
